import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import T from 'prop-types';
import ErrorCodeTypeSelection from './ErrorCodeTypeSelection';
import { loadErrorCode, loadAlarmConfig } from '../../../../redux/machines/actions';
import { getAlarmConfig, getErrorCode } from '../../../../redux/machines/selectors';
import { loadMessagesIrisV3 } from '../../../../redux/machines_v2/actions';
import { getMessagesIrisV3 } from '../../../../redux/machines_v2/selectors';

import { isIrisInsideVariant, PlcType } from '../../../../attrs/plcConfigValues';
import ErrorCodeTypeSelectionIrisV3 from './IrisV3/ErrorCodeTypeSelectionIrisV3';

const ConnectedErrorCodeContent = ({ plcType }) => {
  const dispatch = useDispatch();
  const { loadingState, data } = useSelector(getErrorCode);
  const { data: dataMessages, loadingState: loadingStateMessageIrisV3 } = useSelector(getMessagesIrisV3);
  const { loadingState: loadingAlarmConfig, data: dataAlarmConfig } = useSelector(getAlarmConfig);
  

  const { machineId } = useParams();

  const callLoadErrorOrAlarm = useCallback(() => {
    if (isIrisInsideVariant(plcType.plc_type)) {
      dispatch(loadAlarmConfig(machineId));
    } else {
      dispatch(loadErrorCode(machineId));
    }
  }, [dispatch, machineId, plcType.plc_type]);

  const loadingResult = useMemo(() => {
    if (isIrisInsideVariant(plcType.plc_type)) {
      return loadingAlarmConfig;
    } else {
      return loadingState;
    }
  }, [plcType.plc_type, loadingAlarmConfig, loadingState]);

  const dataResult = useMemo(() => {
    if (isIrisInsideVariant(plcType.plc_type)) {
      return dataAlarmConfig;
    } else {
      return data;
    }
  }, [plcType.plc_type, dataAlarmConfig, data]);

  useEffect(() => {
    if (plcType.plc_type === PlcType.IRIS_V3) {
      dispatch(loadMessagesIrisV3(machineId));
    } else {
      callLoadErrorOrAlarm();
    }
  }, [callLoadErrorOrAlarm, dispatch, machineId, plcType.plc_type]);

  return (
    <>
      {plcType.plc_type === PlcType.IRIS_V3 ? (
        <ErrorCodeTypeSelectionIrisV3
          loadingState={loadingStateMessageIrisV3}
          reloadAction={() => dispatch(loadMessagesIrisV3(machineId))}
          data={dataMessages}
          machineId={machineId}
          plcType={plcType}
        />
      ) : (
        <ErrorCodeTypeSelection
          loadingState={loadingResult}
          reloadAction={callLoadErrorOrAlarm}
          data={dataResult}
          machineId={machineId}
          plcType={plcType}
        />
      )}
    </>
  );
};

ConnectedErrorCodeContent.propTypes = {
  plcType: T.shape({
    plc_type: T.string,
    autoconfig_enabled: T.bool
  }).isRequired
};

export default ConnectedErrorCodeContent;
